import * as t from "io-ts";

export const User = t.type({
  logo: t.union([t.null, t.string]),
  name: t.union([t.null, t.string]),
});
export type User = t.TypeOf<typeof User>;

export const UserResponse = t.type({
  user: t.union([t.null, User])
});
export type UserResponse = t.TypeOf<typeof UserResponse>;
export type UserResponseOutput = t.OutputOf<typeof UserResponse>;
